import { forwardRef } from 'react';

import { TColorNames } from '@_shared/styles';
import { TTextAlignProperty } from '@_shared/types/property';

import { TTypographyType } from './Typography.type';
import {
  Body, Display, Headline, Label, Title,
} from './Typography.style';

export type Props = {
  children: React.ReactNode;

  /** Typography 컴포넌트의 타입을 정합니다. */
  type: TTypographyType;

  /** Typography 컴포넌트의 text-align 스타일을 정합니다. */
  textAlign?: TTextAlignProperty;

  /** Typography 컴포넌트의 italic체 유무를 지정합니다. */
  italic?: boolean;

  /** Typography 컴포넌트의 밑줄 유무를 지정합니다. */
  underline?: boolean;

  /** Typography 컴포넌트의 색상을 정합니다. */
  color?: TColorNames;

  /** Typography 컴포넌트의 줄 바꿈 숫자를 지정합니다. */
  noOfLine?: number;

  /** Typography 컴포넌트의 onClick Event 지정. */
  onClick?: React.MouseEventHandler;
};

const Typography = forwardRef(
  (props: Props, ref: React.ComponentPropsWithRef<React.ElementType>['ref']) => {
    const [type, size] = props.type.split('-') as [
      'display' | 'headline' | 'title' | 'label' | 'body',
      'small' | 'medium' | 'large' | 'mini',
    ];

    switch (type) {
      case 'display':
        return (
          <Display {...props} size={size} ref={ref} onClick={props.onClick}>
            {props.children}
          </Display>
        );
      case 'headline':
        return (
          <Headline {...props} size={size} ref={ref} onClick={props.onClick}>
            {props.children}
          </Headline>
        );
      case 'title':
        return (
          <Title {...props} size={size} ref={ref} onClick={props.onClick}>
            {props.children}
          </Title>
        );
      case 'label':
        return (
          <Label {...props} size={size} ref={ref} onClick={props.onClick}>
            {props.children}
          </Label>
        );
      case 'body':
        return (
          <Body {...props} size={size} ref={ref} onClick={props.onClick}>
            {props.children}
          </Body>
        );
    }
  },
);

Typography.displayName = 'Typography';

export { Typography };
